<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>工作汇报</el-breadcrumb-item>
  <el-breadcrumb-item>绩效查看</el-breadcrumb-item>
</el-breadcrumb>
<el-card>
  
  <el-row>
      <el-col :span="12">
          时间：
<el-select v-model="value" placeholder="考核年份">
        <el-option
          v-for="item in year"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select v-model="value3" placeholder="考核月份">
        <el-option
          label="无"
          value="0">
        </el-option>
        <el-option
          v-for="item in moun"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
  </el-col>
<el-col :span="2"><div class="grid-content bg-purple"> <el-button type="primary" @click="getPerformance">查询</el-button></div></el-col>
</el-row>
<el-table
  ref="multipleTable"
  :data="viewList"
  border
  show-overflow-tooltip="true"
  tooltip-effect="dark"
  style="width: 100%"
  >
  <el-table-column
    label="工号"
    width="120"
    :show-overflow-tooltip="true"
    prop="work_number">
    
  </el-table-column>

  <el-table-column
    label="姓名"
    width="120"
    :show-overflow-tooltip="true"
    prop="user_name">
  </el-table-column>
  <el-table-column
      label="检查出勤次数/出勤率"
      width="120"
      :show-overflow-tooltip="true"
      prop="class_attendence">
    </el-table-column>
    <el-table-column
      label="周考,晚自习值班次数/出勤率"
      width="120"
      :show-overflow-tooltip="true"
      prop="late_attendence">
    </el-table-column>
    <el-table-column
      label="检查宿舍次数/通报次数"
      width="190"
      :show-overflow-tooltip="true"
      prop="dormitory_times">
    </el-table-column>
    <el-table-column
      label="谈话次数"
      width="120"
      :show-overflow-tooltip="true"
      prop="talk_record">
    </el-table-column>
    <el-table-column
      label="评价好评率"
      width="120"
      :show-overflow-tooltip="true"
      prop="feedback">
    </el-table-column>
    <el-table-column
    label="学生投诉/家长投诉"
    width="120"
    :show-overflow-tooltip="true"
    prop="user_complaint">
  </el-table-column>
  <el-table-column
    label="绩效"
    width="120"
    :show-overflow-tooltip="true"
    prop="perf"
    :formatter="perfFormatter">
  </el-table-column>
  <el-table-column
    label="绩效时间"
    width="120"
    :show-overflow-tooltip="true"
    prop="write_date"
    :formatter="writeDateFormatter">
  </el-table-column>
  <el-table-column
    label="生成时间"
    width="120"
    :show-overflow-tooltip="true"
    prop="create_time"
    :formatter="createTimeFormatter">
  </el-table-column>
</el-table>
<div class="block">
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="currentPage4"
    :page-sizes="[10, 20, 30, 40]"
    :page-size="10"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total">
  </el-pagination>
</div>

</el-card>




</div>
</template>

<script>
export default {
created(){
  this.getYearDateList()
  this.getMonthlIST()
  this.getPerformance()
},
data(){
  return{
      year:[],
      moun:[],
      userType:'getTPerformance',
      value: '',
      value3: '',
      viewList:[],
      formData:{
          particulars:'',
          fileList7:[],
        fileList8:[],
        fileList:[],
          is_public:false,
          file:null
      },
      querys:{
       writeDate:null,
        pageNum:null,
        pageSize:null,
        isWeeks:4,
        isYear:'false'
      },
      total:null,
      currentPage4: 1,
  }
},methods:{
  handleSizeChange(val) {
      if(val!=null||val!=''){
        this.querys.pageSize=val
      }
      console.log(`每页 ${val} 条`);
      this.getPerformance()
    },
    handleCurrentChange(val) {
      if(val!=null||val!=''){
        this.querys.pageNum=val
      }
      console.log(`当前页: ${val}`);
      this.getPerformance()
    },
  getPerformance(){
    let moundVal=0;
    if(this.value3=='0'){  
      this.querys.isYear='true'
      moundVal=1
    }else{
      this.querys.isYear='false'
      moundVal=this.value3
    }
      let kpidate=this.value+'-'+(moundVal>9?moundVal:'0'+moundVal)
      this.querys.writeDate=kpidate
  this.axios.get("/performance/getLPerf"+this.$formateDate.tansParams(this.querys))
           .then(resp=>{
            if(resp.data.status==1){
              this.total=resp.data.result.total
              this.viewList=resp.data.result.rows
            }
           })
},writeDateFormatter(row,column,cellValue){
  var date =	new Date(cellValue);
 let year= date.getFullYear()
 let month= date.getMonth()+1
return year+'/'+month
},createTimeFormatter(row,column,cellValue){
  var date =	new Date(cellValue).toLocaleString();
 
return date
},perfFormatter(row,column,cellValue,index){
   let datas= cellValue*100+'%'
  return datas
  },
getYearDateList(){
    var date = new Date()
  var Y = date.getFullYear()
 let yearList=[]
 yearList.push(Y-1)
 yearList.push(Y)
 yearList.push(Y+1)
  this.value=Y
 this.year=yearList
     },   getMonthlIST(){
      var date = new Date()
      var M = (date.getMonth() + 1)
     
        this.value3=M
      
      let mounList=[]
      for (let index = 1; index <13; index++) {
      mounList.push(index)  
      }
    this.moun=mounList
    // this.value3=M
     },

    
    
    
}

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/instructor/viewMonthIPerformance.vue